
import React from 'react';

const OilFaqSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="page-container">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-autocare-blue bg-autocare-blue/10 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl font-bold text-autocare-blue mb-4">Frequently Asked Questions</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about motor oil, oil changes, and vehicle maintenance.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto divide-y divide-gray-200">
          <div className="py-5">
            <h3 className="text-lg font-semibold text-autocare-blue mb-2">How often should I change my oil?</h3>
            <p className="text-gray-600">
              For conventional oil, typically every 5,000-8,000 KM. Synthetic oil can last longer, usually 12,000-24,000 KM. Always check your vehicle's manual for manufacturer recommendations.
            </p>
          </div>
          
          <div className="py-5">
            <h3 className="text-lg font-semibold text-autocare-blue mb-2">What happens if I don't change my oil regularly?</h3>
            <p className="text-gray-600">
              Old oil loses its effectiveness and can cause engine damage, reduced performance, poor fuel economy, and eventually engine failure if neglected for too long.
            </p>
          </div>
          
          <div className="py-5">
            <h3 className="text-lg font-semibold text-autocare-blue mb-2">Is synthetic oil worth the extra cost?</h3>
            <p className="text-gray-600">
              For many drivers, yes. Synthetic oil provides better protection, especially in extreme temperatures, and allows for longer intervals between changes, which can offset the higher cost over time.
            </p>
          </div>
          
          <div className="py-5">
            <h3 className="text-lg font-semibold text-autocare-blue mb-2">What do the numbers in oil viscosity (like 5W-30) mean?</h3>
            <p className="text-gray-600">
              The first number (5W) indicates how the oil flows in cold temperatures (W stands for winter). The second number (30) shows the viscosity at normal operating temperature. Lower numbers mean thinner oil.
            </p>
          </div>
          
          <div className="py-5">
            <h3 className="text-lg font-semibold text-autocare-blue mb-2">Can I switch between different oil types?</h3>
            <p className="text-gray-600">
              Yes, you can switch between conventional, synthetic blend, and full synthetic oils without harming your engine. However, once you switch to synthetic, it's best to continue using that type.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OilFaqSection;
